import { render, staticRenderFns } from "./TicketQueues.vue?vue&type=template&id=68cf05e9&scoped=true&"
import script from "./TicketQueues.vue?vue&type=script&lang=js&"
export * from "./TicketQueues.vue?vue&type=script&lang=js&"
import style0 from "./TicketQueues.vue?vue&type=style&index=0&id=68cf05e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf05e9",
  null
  
)

export default component.exports